import { UserModel } from './user';

export interface FilterModel {
    field: string;
    operator: OperatorFilterEnum;
    value: any;
    values?: string[];
  }
  
export interface FieldFilter{
    name: string;
    label: string;
    type: string;
    multiple: boolean;
    value: any;
    values: any[];
    options: any[] | OptionFilter[];
    selectedUser?: UserModel | null;
    noDataLabel?: string;
    placeholder?: string;
    searchField?: string;
  }

  export interface OptionFilter {
    value: any;
    label: string;
  }

export enum OperatorFilterEnum {
  GREATER_OR_EQUAL_THAN = 'GREATER_OR_EQUAL_THAN',
  LESS_OR_EQUAL_THAN = 'LESS_OR_EQUAL_THAN',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  EQUALS = 'EQUALS',
  LIKE = 'LIKE',
  NOT_EQ = 'NOT_EQ',
  IN = 'IN',
  IS_NULL = 'IS_NULL',
  IS_EMPTY = 'IS_EMPTY',
  BETWEEN = 'BETWEEN'
}
